import { render } from "./DesktopMenu.vue?vue&type=template&id=546b1b78"
import script from "./DesktopMenu.vue?vue&type=script&lang=js"
export * from "./DesktopMenu.vue?vue&type=script&lang=js"

import "./DesktopMenu.vue?vue&type=style&index=0&id=546b1b78&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__